import {QuizType} from "../enums/quizType.enum";
import {RegexConstants} from "../constants/regex.constants";
import {useTheme} from "@mui/material";
import ComparisonConstants from "../constants/comparison.constants";

const useCategoryComparison = () => {
    
    const theme = useTheme();
    
    const getComparisonThemeColour = (comparisonValue: string, quizType: QuizType) => {

        switch (quizType) {
            case QuizType.StarSign: {
                if(!RegexConstants.DIGITS_ONLY.test(comparisonValue)) {
                    return theme.palette.thatsMe.comparisons.bad;
                }
                
                const numberValue = Number(comparisonValue);
                
                if(numberValue <= ComparisonConstants.PercentagePivots.bad) {
                    return theme.palette.thatsMe.comparisons.bad;
                }
                
                if(numberValue <= ComparisonConstants.PercentagePivots.neutral) {
                    return theme.palette.thatsMe.comparisons.fine;
                }

                if(numberValue <= ComparisonConstants.PercentagePivots.good) {
                    return theme.palette.thatsMe.comparisons.good;
                }
                
                return theme.palette.thatsMe.comparisons.amazing;
            }
            case QuizType.MBTI: {

                if(comparisonValue === ComparisonConstants.MBTIAnswers.amazing)
                {
                    return theme.palette.thatsMe.comparisons.amazing;
                }

                if(comparisonValue === ComparisonConstants.MBTIAnswers.good)
                {
                    return theme.palette.thatsMe.comparisons.good;
                }

                if(comparisonValue === ComparisonConstants.MBTIAnswers.fine)
                {
                    return theme.palette.thatsMe.comparisons.fine;
                }

                return theme.palette.thatsMe.comparisons.bad;
            }
        }

        return theme.palette.thatsMe.comparisons.bad;
    };
    
    return {getComparisonThemeColour};
};

export { useCategoryComparison };